(function () {
  'use strict';

  var FONT_GROUPS = [
    {
      id: 'block',
      label: 'Block / Serif / Sans',
      fonts: [
        { name: 'Arial', css: 'Arial, Helvetica, sans-serif', chip: 'Sans' },
        { name: 'Book Antiqua', css: '"Book Antiqua", Palatino, "Palatino Linotype", serif', chip: 'Serif' },
        { name: 'Bookman Old Style', css: '"Bookman Old Style", Bookman, Georgia, serif', chip: 'Serif' },
        { name: 'Britannic Bold', css: '"Britannic Bold", Impact, Haettenschweiler, sans-serif', chip: 'Sans' },
        { name: 'Calibri', css: 'Calibri, Candara, "Segoe UI", Optima, Arial, sans-serif', chip: 'Sans' },
        { name: 'Cambria Math', css: 'Cambria, Georgia, serif', chip: 'Serif' },
        { name: 'CASTELLAR', css: 'Castellar, "Copperplate Gothic Light", Copperplate, fantasy', chip: 'Display' },
        { name: 'Century', css: 'Century, "Century Schoolbook", Georgia, serif', chip: 'Serif' },
        { name: 'Century Gothic', css: '"Century Gothic", CenturyGothic, AppleGothic, sans-serif', chip: 'Sans' },
        { name: 'Courier New', css: '"Courier New", Courier, monospace', chip: 'Mono' },
        { name: 'ENGRAVERS MT', css: '"Engravers MT", "Copperplate Gothic Bold", Copperplate, serif', chip: 'Display' },
        { name: 'Franklin Gothic Book', css: '"Franklin Gothic Book", "Franklin Gothic Medium", Arial Narrow, sans-serif', chip: 'Sans' },
        { name: 'Futura Bk BT', css: 'Futura, "Trebuchet MS", Arial, sans-serif', chip: 'Sans' },
        { name: 'Gabriola', css: 'Gabriola, "Segoe Script", cursive', chip: 'Script' },
        { name: 'Georgia', css: 'Georgia, "Times New Roman", serif', chip: 'Serif' },
        { name: 'Imprint MT Shadow', css: '"Imprint MT Shadow", Georgia, serif', chip: 'Display' },
        { name: 'Letter Gothic Std', css: '"Letter Gothic Std", "Lucida Console", monospace', chip: 'Mono' },
        { name: 'LICENSE PLATE', css: '"Courier New", Courier, monospace', chip: 'Mono' },
        { name: 'Lucida Bright', css: '"Lucida Bright", "Lucida Fax", Georgia, serif', chip: 'Serif' },
        { name: 'Old English Text', css: '"Old English Text MT", "Times New Roman", serif', chip: 'Display' },
        { name: 'Prestige Elite', css: '"Prestige Elite Std", "Courier New", monospace', chip: 'Mono' },
        { name: 'Rockwell', css: 'Rockwell, "Courier New", Georgia, serif', chip: 'Serif' },
        { name: 'STENCIL', css: 'Stencil, "Arial Black", Impact, sans-serif', chip: 'Display' },
        { name: 'Tahoma', css: 'Tahoma, Verdana, sans-serif', chip: 'Sans' },
        { name: 'Tekton', css: 'Tekton, "Comic Sans MS", cursive', chip: 'Display' },
        { name: 'Times New Roman', css: '"Times New Roman", Times, serif', chip: 'Serif' },
        { name: 'TRAJAN PRO', css: '"Trajan Pro", Cinzel, "Times New Roman", serif', chip: 'Display' },
        { name: 'Typewriter', css: '"Courier New", Courier, monospace', chip: 'Mono' },
        { name: 'Verdana', css: 'Verdana, Geneva, sans-serif', chip: 'Sans' }
      ]
    },
    {
      id: 'script',
      label: 'Script',
      fonts: [
        { name: 'A Gentle Touch', css: '"Great Vibes", cursive', chip: 'Approx' },
        { name: 'Alex Brush', css: '"Alex Brush", cursive', chip: 'Web' },
        { name: 'Allura', css: 'Allura, cursive', chip: 'Approx' },
        { name: 'ALS Script', css: '"Dancing Script", cursive', chip: 'Approx' },
        { name: 'Altitude', css: 'Pacifico, cursive', chip: 'Approx' },
        { name: 'Amazone BT', css: '"Great Vibes", cursive', chip: 'Approx' },
        { name: 'Angelina', css: 'Parisienne, cursive', chip: 'Approx' },
        { name: 'Apple Chancery', css: '"Apple Chancery", "Snell Roundhand", cursive', chip: 'System' },
        { name: 'Birds of Paradise', css: '"Great Vibes", cursive', chip: 'Approx' },
        { name: 'Bolero Script', css: 'Allura, cursive', chip: 'Approx' },
        { name: 'Bradley Hand ITC', css: '"Bradley Hand", "Comic Sans MS", cursive', chip: 'System' },
        { name: 'Brush Script MT', css: '"Brush Script MT", cursive', chip: 'System' },
        { name: 'Cotillion', css: '"Great Vibes", cursive', chip: 'Approx' },
        { name: 'Dancing Script', css: '"Dancing Script", cursive', chip: 'Web' },
        { name: 'Edwardian Script', css: '"Great Vibes", "Pinyon Script", cursive', chip: 'Approx' },
        { name: 'Freehand521 BT', css: 'Caveat, cursive', chip: 'Approx' },
        { name: 'Freestyle Script', css: 'Pacifico, cursive', chip: 'Approx' },
        { name: 'French Script', css: '"French Script MT", "Great Vibes", cursive', chip: 'System' },
        { name: 'Great Vibes', css: '"Great Vibes", cursive', chip: 'Web' },
        { name: 'Honey Script', css: 'Sacramento, cursive', chip: 'Approx' },
        { name: 'Kill Eyes Wide Open', css: 'Satisfy, cursive', chip: 'Approx' },
        { name: 'Lucida Calligraphy', css: '"Lucida Calligraphy", "Apple Chancery", cursive', chip: 'System' },
        { name: 'Lucida Handwriting', css: '"Lucida Handwriting", "Segoe Script", cursive', chip: 'System' },
        { name: 'Monotype Corsiva', css: '"Monotype Corsiva", "Apple Chancery", cursive', chip: 'System' },
        { name: 'Petit Formal Script', css: '"Petit Formal Script", cursive', chip: 'Web' },
        { name: 'Segoe Script', css: '"Segoe Script", "Bradley Hand", cursive', chip: 'System' },
        { name: 'Snell Roundhand', css: '"Snell Roundhand", "Apple Chancery", cursive', chip: 'System' },
        { name: 'Tangerine', css: 'Tangerine, cursive', chip: 'Web' },
        { name: 'What I Want For Christmas', css: '"Great Vibes", cursive', chip: 'Approx' },
        { name: 'Zeyada', css: 'Zeyada, cursive', chip: 'Web' }
      ]
    },
    {
      id: 'monogram',
      label: 'Monogram',
      fonts: [
        { name: 'FREE MONOGRAM', css: '"Cinzel Decorative", Cinzel, serif', chip: 'Monogram' },
        { name: 'MONOGRAM KK SC', css: '"Cinzel Decorative", Cinzel, serif', chip: 'Monogram' }
      ]
    }
  ];

  var TYPE_LABELS = {
    text: 'Text',
    image: 'Image',
    both: 'Text + Image',
    custom: 'Custom'
  };

  function money(cents, format, currency) {
    var amount = (Number(cents) / 100).toFixed(2);
    var formatted;
    if (!format) formatted = '$' + amount;
    else formatted = format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(Number(cents) / 100)))
      .replace(/\{\{\s*amount\s*\}\}/, amount);
    if (currency && formatted.indexOf(currency) === -1) formatted += ' ' + currency;
    return formatted;
  }

  function parseMoneyToCents(text) {
    if (!text) return null;
    var cleaned = String(text).replace(/[^0-9.,]/g, '');
    if (!cleaned) return null;
    // Prefer last comma/dot as decimal separator
    var normalized = cleaned;
    if (cleaned.indexOf(',') > -1 && cleaned.indexOf('.') > -1) {
      if (cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
        normalized = cleaned.replace(/\./g, '').replace(',', '.');
      } else {
        normalized = cleaned.replace(/,/g, '');
      }
    } else if (cleaned.indexOf(',') > -1) {
      normalized = cleaned.replace(',', '.');
    }
    var n = parseFloat(normalized);
    if (isNaN(n)) return null;
    return Math.round(n * 100);
  }

  function readDomProductPriceCents() {
    var el = document.querySelector('[data-product-price]');
    if (!el) return null;
    return parseMoneyToCents(el.textContent);
  }

  function initRoot(root) {
    if (!root || root.dataset.reInit) return;
    root.dataset.reInit = '1';

    var enable = root.querySelector('[data-eng-enable]');
    var panel = root.querySelector('[data-eng-panel]');
    var modes = root.querySelectorAll('[data-eng-mode]');
    var feeBox = root.querySelector('[data-eng-fee]');
    var feeAmt = root.querySelector('[data-eng-fee-amount]');
    var feeLine = root.querySelector('[data-eng-fee-line]');
    var feeSep = root.querySelector('[data-eng-fee-sep]');
    var estWrap = root.querySelector('[data-eng-est-wrap]');
    var estTotal = root.querySelector('[data-eng-est-total]');
    var atcEst = root.querySelector('[data-eng-atc-est]');
    var atcEstLine = root.querySelector('[data-eng-atc-est-line]');
    var compose = root.querySelector('[data-eng-compose]');
    var textWrap = root.querySelector('[data-eng-text-wrap]');
    var imageWrap = root.querySelector('[data-eng-image-wrap]');
    var customWrap = root.querySelector('[data-eng-custom-wrap]');
    var textInput = root.querySelector('[data-eng-text]');
    var fileInput = root.querySelector('[data-eng-file]');
    var fileLabel = root.querySelector('[data-eng-file-label]');
    var sidePriceEl = root.querySelector('[data-eng-side-price]');
    var sideHidden = root.querySelector('[data-prop-side]');
    var frontLabel = root.querySelector('[data-eng-front-label]');
    var customFrontLabel = root.querySelector('[data-eng-custom-front-label]');
    var customLabel = root.querySelector('[data-eng-custom-label]');
    var backBlock = root.querySelector('[data-eng-back]');
    var backTextWrap = root.querySelector('[data-eng-back-text]');
    var backImageWrap = root.querySelector('[data-eng-back-image]');
    var textBack = root.querySelector('[data-eng-text-back]');
    var notesBack = root.querySelector('[data-prop-back-notes]');
    var notesBackLabel = root.querySelector('[data-eng-back-notes-label]');
    var fileBack = root.querySelector('[data-eng-file-back]');
    var countBack = root.querySelector('[data-eng-count-back]');
    var overflowBack = root.querySelector('[data-eng-overflow-help-back]');
    var previewSides = root.querySelector('[data-eng-preview-sides]');
    var previewSide = 'front';
    var frontPicker = null;
    var backPicker = null;
    var customInput = root.querySelector('[data-eng-custom]');
    var notesInput = root.querySelector('[data-prop-notes]');
    var notesWrap = root.querySelector('[data-eng-notes-wrap]');
    var notesLabel = notesWrap ? notesWrap.querySelector('[data-eng-notes-label]') : null;
    var fontHidden = root.querySelector('[data-prop-font]');
    var typeHidden = root.querySelector('[data-prop-type]');
    var countEl = root.querySelector('[data-eng-count]');
    var overflowHelp = root.querySelector('[data-eng-overflow-help]');
    var preview = root.querySelector('[data-eng-preview]');
    var fontBtn = root.querySelector('[data-font-btn]');
    var fontBtnLabel = root.querySelector('[data-font-btn-label]');
    var fontDropdown = root.querySelector('[data-font-dropdown]');
    var fontSearch = root.querySelector('[data-font-search]');
    var fontGroups = root.querySelector('[data-font-groups]');
    var maxChars = parseInt(root.dataset.maxChars || '30', 10) || 30;
    // Presentment cents from the engraving variants (active currency). Fallbacks are CAD shop cents.
    function priceAttr(name, fallback) {
      var n = parseInt(root.dataset[name] || '', 10);
      return isNaN(n) ? fallback : n;
    }
    var prices = {
      text: priceAttr('priceText', 3900),
      image: priceAttr('priceImage', 6900),
      both: priceAttr('priceBoth', 8900),
      side: priceAttr('priceSide', 2900),
      custom: 0
    };
    var variants = {
      text: root.dataset.variantText || '50615385424069',
      image: root.dataset.variantImage || '50615385456837',
      both: root.dataset.variantBoth || '50615385489605',
      side: root.dataset.variantSide || '50618025214149',
      custom: ''
    };
    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var currencyCode = root.dataset.currency || '';
    var productPriceCents = parseInt(root.dataset.productPriceCents || '0', 10) || 0;
    var selectedFont = { name: 'Georgia', css: 'Georgia, "Times New Roman", serif' };
    var form = root.closest('form') || document.querySelector('.product-single__form');

    // Prefer live DOM price if Liquid cents missing
    if (!productPriceCents) {
      var domPrice = readDomProductPriceCents();
      if (domPrice != null) productPriceCents = domPrice;
    }

    function currentMode() {
      var checked = root.querySelector('[data-eng-mode]:checked');
      return checked ? checked.value : 'text';
    }

    function currentSides() {
      var checked = root.querySelector('[data-eng-side]:checked');
      return checked && checked.value === 'both' ? 'both' : 'one';
    }

    function bothSidesOn() {
      return currentSides() === 'both';
    }

    function sideFeeCents(mode) {
      if (mode === 'custom' || !bothSidesOn()) return 0;
      return prices.side || 0;
    }

    function feeCentsFor(mode) {
      if (mode === 'custom') return 0;
      return (prices[mode] || 0) + sideFeeCents(mode);
    }

    function setHidden(el, hidden) {
      if (!el) return;
      el.hidden = !!hidden;
      if (hidden) el.setAttribute('hidden', '');
      else el.removeAttribute('hidden');
    }

    function syncPreviewSideButtons() {
      var buttons = root.querySelectorAll('[data-eng-preview-side]');
      for (var i = 0; i < buttons.length; i++) {
        var on = buttons[i].getAttribute('data-eng-preview-side') === previewSide;
        buttons[i].classList.toggle('is-active', on);
        buttons[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    }

    // Front/Back preview source: which text+font feed the tag silhouette.
    // Typing/focusing a side's fields switches the live preview to that side.
    function setPreviewSide(side, opts) {
      opts = opts || {};
      var next = side === 'back' ? 'back' : 'front';
      var mode = currentMode();
      var showText = mode === 'text' || mode === 'both';
      if (!bothSidesOn() || !showText) next = 'front';
      previewSide = next;
      // One text box: Back hides the front field (words kept) and shows the back field, which starts empty.
      root.classList.toggle('is-preview-back', previewSide === 'back');
      if (frontLabel) frontLabel.textContent = previewSide === 'back' ? 'Back' : 'Front';
      syncPreviewSideButtons();
      updatePreview();
      if (opts.focusField) {
        var el = previewSide === 'back' ? textBack : textInput;
        if (el && !el.disabled) {
          try { el.focus({ preventScroll: true }); } catch (e) { try { el.focus(); } catch (e2) {} }
        }
      }
    }

    function placeAtcEst() {
      if (!atcEst || !form) return;
      var btn = form.querySelector('[data-add-to-cart]');
      if (!btn) return;
      var parent = btn.parentElement;
      if (!parent) return;
      // Keep est. total immediately above the ATC button (never insertBefore(parent)).
      try {
        if (atcEst.parentElement !== parent || atcEst.nextElementSibling !== btn) {
          parent.insertBefore(atcEst, btn);
        }
      } catch (err) {
        // Payment-button DOM can shuffle; skip rather than aborting initRoot.
      }
    }

    // Main PDP price (Impulse). Not compare-at [data-compare-price], not Shop Pay.
    // Theme writes [data-product-price] in variantPriceChange AFTER document variant:change,
    // so the overlay is applied in a microtask and our own writes are ignored.
    var mainPrice = {
      anchor: null,
      observer: null,
      original: null,
      written: null,
      ignore: false,
      queued: false
    };

    function priceScope() {
      return root.closest('[data-section-type="product"]') || root.closest('.product-single') || document;
    }

    function findMainPriceNode() {
      var scope = priceScope();
      var node = scope.querySelector('[data-product-price]');
      if (node) return node;
      return document.querySelector('[data-product-price]');
    }

    function onMainPriceMutation() {
      if (mainPrice.ignore) {
        mainPrice.ignore = false;
        return;
      }
      var node = findMainPriceNode();
      if (!node) return;
      var text = node.textContent;
      if (mainPrice.written != null && text === mainPrice.written) return;
      if (mainPrice.original != null && text === mainPrice.original) return;
      mainPrice.original = text;
      var cents = parseMoneyToCents(text);
      if (cents != null && cents !== productPriceCents) {
        productPriceCents = cents;
        root.dataset.productPriceCents = String(cents);
      }
      updateEstTotal();
    }

    function bindMainPriceObserver() {
      var node = findMainPriceNode();
      var anchor = (node && (node.closest('.rudix-price-row') || node.closest('.product-block--price'))) || node;
      if (!anchor || !window.MutationObserver) return;
      if (mainPrice.anchor === anchor && mainPrice.observer) return;
      if (mainPrice.observer) mainPrice.observer.disconnect();
      mainPrice.anchor = anchor;
      mainPrice.observer = new MutationObserver(onMainPriceMutation);
      mainPrice.observer.observe(anchor, { childList: true, characterData: true, subtree: true });
    }

    function applyMainPrice() {
      var node = findMainPriceNode();
      if (!node) return;
      bindMainPriceObserver();
      var text = node.textContent;
      if (!(mainPrice.written != null && text === mainPrice.written)) {
        mainPrice.original = text;
      }
      var on = !!(enable && enable.checked);
      var mode = currentMode();
      var fee = on ? feeCentsFor(mode) : 0;
      var show = on && mode !== 'custom' && fee > 0;
      var next = show ? money(productPriceCents + fee, moneyFormat, currencyCode) : mainPrice.original;
      if (next == null) return;
      if (node.textContent !== next) {
        mainPrice.ignore = true;
        node.textContent = next;
      }
      mainPrice.written = show ? next : null;
    }

    function queueMainPriceSync() {
      if (mainPrice.queued) return;
      mainPrice.queued = true;
      var run = function () {
        mainPrice.queued = false;
        applyMainPrice();
      };
      if (window.queueMicrotask) window.queueMicrotask(run);
      else setTimeout(run, 0);
    }

    function updateEstTotal() {
      var on = !!(enable && enable.checked);
      var mode = currentMode();
      var fee = feeCentsFor(mode);
      var total = productPriceCents + (on ? fee : 0);
      queueMainPriceSync();

      if (!on) {
        if (atcEst) {
          atcEst.hidden = true;
          atcEst.setAttribute('hidden', '');
        }
        return;
      }

      if (mode === 'custom') {
        if (feeBox) feeBox.classList.add('is-quote');
        if (feeLine) {
          var sideBit = bothSidesOn() ? ' (both sides, no extra charge)' : '';
          feeLine.innerHTML = 'Custom engraving' + sideBit + ' · <strong>Quote — we’ll confirm</strong>';
        }
        if (feeSep) feeSep.hidden = true;
        if (estWrap) {
          estWrap.hidden = false;
          if (estTotal) estTotal.textContent = money(productPriceCents, moneyFormat, currencyCode) + ' + quote';
        }
        if (atcEst && atcEstLine) {
          placeAtcEst();
          atcEst.hidden = false;
          atcEst.removeAttribute('hidden');
          atcEstLine.innerHTML = 'Custom engraving (quote) · Product <strong>' + money(productPriceCents, moneyFormat, currencyCode) + '</strong>';
        }
        return;
      }

      if (feeBox) feeBox.classList.remove('is-quote');
      var sideFee = sideFeeCents(mode);
      var sideNote = sideFee
        ? ' <span class="rudix-engraving__side-fee">includes +' + money(sideFee, moneyFormat, currencyCode) + ' second side</span>'
        : '';
      if (feeLine) {
        feeLine.innerHTML = '+ Engraving <strong data-eng-fee-amount>' + money(fee, moneyFormat, currencyCode) + '</strong>' + sideNote;
        // re-query after innerHTML replace
        feeAmt = root.querySelector('[data-eng-fee-amount]');
      } else if (feeAmt) {
        feeAmt.textContent = money(fee, moneyFormat, currencyCode);
      }
      if (feeSep) feeSep.hidden = false;
      if (estWrap) estWrap.hidden = false;
      if (estTotal) estTotal.textContent = money(total, moneyFormat, currencyCode);

      if (atcEst && atcEstLine) {
        placeAtcEst();
        atcEst.hidden = false;
        atcEst.removeAttribute('hidden');
        atcEstLine.innerHTML =
          '+ Engraving <strong>' + money(fee, moneyFormat, currencyCode) + '</strong>' +
          (sideFeeCents(mode) ? ' <span class="rudix-engraving__side-fee">includes +' + money(sideFeeCents(mode), moneyFormat, currencyCode) + ' second side</span>' : '') +
          ' · Est. total <strong>' + money(total, moneyFormat, currencyCode) + '</strong>';
      }
    }

    function setPropsEnabled(on) {
      var liveFont = root.querySelector('[data-prop-font]') || fontHidden;
      var fontBackHidden = root.querySelector('[data-prop-font-back]');
      [liveFont, textInput, notesInput, typeHidden, customInput, sideHidden, textBack, fontBackHidden, notesBack].forEach(function (el) {
        if (!el) return;
        el.disabled = !on;
      });
      if (!on && fileInput) fileInput.disabled = true;
      if (!on && fileBack) fileBack.disabled = true;
      if (!on && typeHidden) typeHidden.value = '';
      if (!on && sideHidden) sideHidden.value = '';
      // Image has no text. Do not leave Font / Back font enabled after the blanket toggle.
      if (on) {
        var modeNow = currentMode();
        var textNow = modeNow === 'text' || modeNow === 'both';
        if (liveFont) liveFont.disabled = !textNow;
        if (fontBackHidden) fontBackHidden.disabled = !(textNow && bothSidesOn());
      }
    }

    function fitPreviewText() {
      if (!preview) return;
      var t = preview.textContent || '';
      if (!t) {
        preview.style.fontSize = '';
        return;
      }
      // Measure against the light engraving box (preview element itself)
      var maxPx = 15;
      var minPx = 6;
      preview.style.fontSize = maxPx + 'px';
      preview.style.lineHeight = '1.12';
      // Shrink until scroll box fits (with tiny tolerance)
      var guard = 0;
      while (guard < 40 && maxPx > minPx) {
        var overflowY = preview.scrollHeight - preview.clientHeight > 1;
        var overflowX = preview.scrollWidth - preview.clientWidth > 1;
        if (!overflowY && !overflowX) break;
        maxPx -= 0.5;
        preview.style.fontSize = maxPx + 'px';
        guard++;
      }
    }

    function activePreviewFont() {
      if (previewSide === 'back' && bothSidesOn() && backPicker) return backPicker.getFont();
      if (frontPicker) return frontPicker.getFont();
      return { name: 'Georgia', css: 'Georgia, "Times New Roman", serif' };
    }

    function updatePreview() {
      var mode = currentMode();
      var showText = mode === 'text' || mode === 'both';
      var tFront = (textInput && textInput.value) || '';
      var tBack = (textBack && textBack.value) || '';
      var useBack = showText && bothSidesOn() && previewSide === 'back';
      var t = useBack ? tBack : tFront;
      if (preview) {
        if (mode === 'image' || mode === 'custom') {
          // Image: no tag mock and never the uploaded file. Custom: compose is hidden.
          preview.textContent = '';
          preview.classList.remove('is-placeholder');
          preview.style.fontSize = '';
        } else if (showText) {
          preview.textContent = t;
          preview.classList.remove('is-placeholder');
          preview.style.fontFamily = activePreviewFont().css;
        } else {
          preview.textContent = '';
          preview.classList.remove('is-placeholder');
        }
      }
      if (countEl) {
        countEl.textContent = String(tFront.length);
        countEl.classList.toggle('is-max', tFront.length >= maxChars);
      }
      if (countBack) {
        countBack.textContent = String(tBack.length);
        countBack.classList.toggle('is-max', tBack.length >= maxChars);
      }
      if (overflowHelp) {
        var showHelp = showText && tFront.length >= maxChars;
        overflowHelp.hidden = !showHelp;
        if (showHelp) overflowHelp.removeAttribute('hidden');
        else overflowHelp.setAttribute('hidden', '');
      }
      if (overflowBack) {
        var showBackHelp = showText && bothSidesOn() && tBack.length >= maxChars;
        overflowBack.hidden = !showBackHelp;
        if (showBackHelp) overflowBack.removeAttribute('hidden');
        else overflowBack.setAttribute('hidden', '');
      }
      // Auto-fit after layout. Words only — never the uploaded file.
      if (mode !== 'image' && mode !== 'custom') {
        requestAnimationFrame(function () {
          fitPreviewText();
          requestAnimationFrame(fitPreviewText);
        });
      }
    }

    function syncModeUI() {
      var mode = currentMode();
      var isCustom = mode === 'custom';
      var showImage = mode === 'image' || mode === 'both';
      // TEXT / BOTH: text + font. IMAGE: hide completely. CUSTOM: hide.
      var showText = mode === 'text' || mode === 'both';
      // Live text-on-tag preview for Text and Both only. Image has no tag mock.
      var showCompose = showText;

      var sidesBoth = bothSidesOn();
      root.classList.toggle('is-custom', isCustom);
      root.classList.toggle('is-text', mode === 'text');
      root.classList.toggle('is-image', mode === 'image');
      root.classList.toggle('is-both', mode === 'both');
      root.classList.toggle('is-sides-both', sidesBoth);

      if (compose) {
        compose.hidden = !showCompose;
        if (!showCompose) compose.setAttribute('hidden', '');
        else compose.removeAttribute('hidden');
      }
      if (textWrap) {
        textWrap.hidden = !showText;
        if (showText) textWrap.removeAttribute('hidden');
        else textWrap.setAttribute('hidden', '');
      }
      if (imageWrap) {
        imageWrap.hidden = !showImage;
        if (showImage) imageWrap.removeAttribute('hidden');
        else imageWrap.setAttribute('hidden', '');
      }
      if (customWrap) {
        customWrap.hidden = !isCustom;
        if (isCustom) customWrap.removeAttribute('hidden');
        else customWrap.setAttribute('hidden', '');
      }

      // Notes: front notes. Both sides renames the property; custom uses its own box.
      if (notesLabel) {
        if (sidesBoth && !isCustom && mode === 'image') {
          notesLabel.innerHTML = 'Front placement notes <span class="rudix-engraving__optional">(optional)</span>';
        } else if (sidesBoth && !isCustom) {
          notesLabel.innerHTML = 'Front notes <span class="rudix-engraving__optional">(optional)</span>';
        } else if (mode === 'image') {
          notesLabel.innerHTML = 'Placement notes <span class="rudix-engraving__optional">(optional)</span>';
        } else {
          notesLabel.innerHTML = 'Notes <span class="rudix-engraving__optional">(optional)</span>';
        }
      }
      if (notesInput) {
        if (mode === 'image') {
          notesInput.placeholder = sidesBoth
            ? 'Front placement, e.g. centered, top, bottom…'
            : 'Where should the logo go? e.g. centered, top, bottom…';
        } else {
          notesInput.placeholder = 'Placement, size preference, special instructions…';
        }
        notesInput.name = (sidesBoth && !isCustom) ? 'properties[Front notes]' : 'properties[Notes]';
        notesInput.disabled = isCustom;
      }
      if (notesBack) {
        notesBack.disabled = !sidesBoth;
        if (mode === 'image') {
          notesBack.placeholder = 'Back placement, e.g. centered, top, bottom…';
        } else if (isCustom) {
          notesBack.placeholder = 'Notes for the back, or leave blank…';
        } else {
          notesBack.placeholder = 'Back placement, size preference, special instructions…';
        }
      }
      if (notesBackLabel) {
        notesBackLabel.innerHTML = (mode === 'image'
          ? 'Back placement notes'
          : (isCustom ? 'Back notes' : 'Back notes')) +
          ' <span class="rudix-engraving__optional">(optional)</span>';
      }

      if (typeHidden) typeHidden.value = TYPE_LABELS[mode] || mode;
      if (sideHidden) {
        sideHidden.disabled = false;
        sideHidden.value = sidesBoth ? 'Both sides' : 'One side';
      }
      var modePriceEls = root.querySelectorAll('[data-eng-mode-price]');
      for (var mpi = 0; mpi < modePriceEls.length; mpi++) {
        var mk = modePriceEls[mpi].getAttribute('data-eng-mode-price');
        if (prices[mk]) modePriceEls[mpi].textContent = money(prices[mk], moneyFormat, currencyCode);
      }
      var fromPriceEl = root.querySelector('[data-eng-from-price]');
      if (fromPriceEl) fromPriceEl.textContent = money(prices.text, moneyFormat, currencyCode);
      if (sidePriceEl) {
        sidePriceEl.textContent = isCustom
          ? 'No charge'
          : ('+' + money(prices.side || 2900, moneyFormat, currencyCode));
      }

      setHidden(frontLabel, !(sidesBoth && !isCustom));
      setHidden(customFrontLabel, !(sidesBoth && isCustom));
      if (customLabel) {
        customLabel.textContent = (sidesBoth ? 'Front notes' : 'Describe your idea');
      }
      if (customInput && sidesBoth) {
        customInput.placeholder = 'Notes for the front…';
      } else if (customInput) {
        customInput.placeholder = 'Tell us what you’d like engraved, placement, style, or another idea…';
      }

      var showBack = sidesBoth;
      setHidden(backBlock, !showBack);
      setHidden(backTextWrap, !(showBack && showText));
      setHidden(backImageWrap, !(showBack && showImage));

      var showPreviewSides = showText && sidesBoth;
      if (!showPreviewSides) previewSide = 'front';
      setHidden(previewSides, !showPreviewSides);
      syncPreviewSideButtons();

      // Enable fields by mode (disabled = not submitted).
      // Re-query font inputs: a stale init-time node leaves the live
      // properties[Font] / properties[Back font] enabled, and Image has no text.
      if (textInput) textInput.disabled = !showText;
      if (textBack) textBack.disabled = !(showText && sidesBoth);
      var liveFont = root.querySelector('[data-prop-font]') || fontHidden;
      var fontBackHidden = root.querySelector('[data-prop-font-back]');
      if (liveFont) liveFont.disabled = !showText;
      if (fontBackHidden) fontBackHidden.disabled = !(showText && sidesBoth);
      if (fileInput) {
        fileInput.disabled = !showImage;
        fileInput.name = (showImage && sidesBoth) ? 'properties[Front artwork]' : 'properties[Engraving Image]';
      }
      if (fileLabel) {
        fileLabel.textContent = (showImage && sidesBoth) ? 'Front artwork' : 'Upload image / logo';
      }
      if (fileBack) fileBack.disabled = !(showImage && sidesBoth);
      if (customInput) {
        customInput.disabled = !isCustom;
        customInput.name = (isCustom && sidesBoth) ? 'properties[Front notes]' : 'properties[Custom request]';
      }

      if (!showImage && fileInput) fileInput.value = '';
      if ((!showImage || !sidesBoth) && fileBack) fileBack.value = '';

      // Font picker: only for Text / Both. Image + Custom keep it closed.
      // Back picker stays closed until the shopper opens it.
      if (isCustom || mode === 'image') {
        closeFontPicker();
      } else if (root.dataset.reLastMode === 'custom' && enable && enable.checked) {
        openFontPicker({ skipFocus: true });
      } else if (root.dataset.reLastMode === 'image' && showText && enable && enable.checked && !root.dataset.reFontPicked) {
        openFontPicker({ skipFocus: true });
      }
      if (!showText || !sidesBoth) {
        if (backPicker) backPicker.close();
      }
      root.dataset.reLastMode = mode;

      // Mode changes while engraving is off must not submit side/text properties.
      if (!(enable && enable.checked)) setPropsEnabled(false);

      updateEstTotal();
      updatePreview();
    }

    function ensureTextModeDefault() {
      var checked = root.querySelector('[data-eng-mode]:checked');
      var textRadio = root.querySelector('[data-eng-mode][value="text"]');
      if (!textRadio) return;
      if (!root.dataset.reModeTouched) {
        textRadio.checked = true;
      } else if (!checked) {
        textRadio.checked = true;
      }
    }

    function createFontPicker(pickerEl) {
      if (!pickerEl) return null;
      var btn = pickerEl.querySelector('[data-font-btn]');
      var btnLabel = pickerEl.querySelector('[data-font-btn-label]');
      var dropdown = pickerEl.querySelector('[data-font-dropdown]');
      var search = pickerEl.querySelector('[data-font-search]');
      var groupsEl = pickerEl.querySelector('[data-font-groups]');
      var hidden = pickerEl.querySelector('input[type="hidden"]');
      var font = { name: 'Georgia', css: 'Georgia, "Times New Roman", serif' };
      var isFront = pickerEl.getAttribute('data-font-picker-role') !== 'back';

      function render(filter) {
        if (!groupsEl) return;
        var q = (filter || '').trim().toLowerCase();
        groupsEl.innerHTML = '';
        FONT_GROUPS.forEach(function (group) {
          var fonts = group.fonts.filter(function (f) {
            return !q || f.name.toLowerCase().indexOf(q) !== -1;
          });
          if (!fonts.length) return;
          var title = document.createElement('div');
          title.className = 'rudix-font-picker__group-title';
          title.textContent = group.label;
          groupsEl.appendChild(title);
          fonts.forEach(function (f) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'rudix-font-picker__option';
            b.setAttribute('role', 'option');
            b.setAttribute('aria-selected', f.name === font.name ? 'true' : 'false');
            b.innerHTML = '<span style="font-family:' + f.css.replace(/"/g, '&quot;') + '">' + f.name + '</span>' +
              '<span class="rudix-font-picker__chip">' + f.chip + '</span>';
            b.addEventListener('click', function () {
              font = f;
              if (hidden) hidden.value = f.name;
              if (btnLabel) {
                btnLabel.textContent = f.name;
                btnLabel.style.fontFamily = f.css;
              }
              if (isFront) root.dataset.reFontPicked = '1';
              close();
              // Keep tag preview on the side whose font was just picked.
              if (bothSidesOn() && (currentMode() === 'text' || currentMode() === 'both')) {
                setPreviewSide(isFront ? 'front' : 'back');
              } else {
                updatePreview();
              }
              render(search ? search.value : '');
            });
            groupsEl.appendChild(b);
          });
        });
      }
      function open(opts) {
        opts = opts || {};
        if (!dropdown || !btn) return;
        dropdown.hidden = false;
        dropdown.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
        if (isFront) root.classList.add('is-fonts-open');
        render(search ? search.value : '');
        if (!opts.skipFocus && search) {
          try { search.focus({ preventScroll: true }); } catch (e) { try { search.focus(); } catch (e2) {} }
        }
      }
      function close() {
        if (!dropdown || !btn) return;
        dropdown.hidden = true;
        dropdown.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
        if (isFront) root.classList.remove('is-fonts-open');
      }
      if (btn) {
        btn.addEventListener('click', function () {
          if (dropdown.hidden) open(); else close();
        });
      }
      if (search) {
        search.addEventListener('input', function () { render(search.value); });
      }
      render('');
      return {
        open: open,
        close: close,
        getFont: function () { return font; }
      };
    }

    function openFontPicker(opts) {
      if (frontPicker) frontPicker.open(opts);
    }
    function closeFontPicker() {
      if (frontPicker) frontPicker.close();
      if (backPicker) backPicker.close();
    }

    modes.forEach(function (m) {
      m.addEventListener('change', function () {
        root.dataset.reModeTouched = '1';
        syncModeUI();
      });
    });
    if (textInput) {
      // Typing in a field never changes Front/Back. Only the Front and Back buttons do.
      textInput.addEventListener('input', function () { updatePreview(); });
    }
    if (fileInput) {
      // Upload is stored as a line-item file only. Never paint it on the tag
      // (Image or Both) — a photo mock reads as a printed sticker, not a laser mark.
      fileInput.addEventListener('change', function () {
        updatePreview();
      });
    }
    root.querySelectorAll('[data-eng-side]').forEach(function (sideRadio) {
      sideRadio.addEventListener('change', function () {
        previewSide = 'front';
        syncModeUI();
      });
    });
    if (textBack) {
      textBack.addEventListener('input', function () { updatePreview(); });
    }
    if (fileBack) {
      fileBack.addEventListener('change', function () { updatePreview(); });
    }
    // Side is committed on pointerdown (see delegated listener) so it lands
    // before focus/input. Click remains a fallback and must NOT preventDefault:
    // cancelling the click kept focus on the front field, whose focus handler
    // then called setPreviewSide('front') and the tag never left the front words.
    root.querySelectorAll('[data-eng-preview-side]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var side = btn.getAttribute('data-eng-preview-side') === 'back' ? 'back' : 'front';
        setPreviewSide(side, { focusField: true });
      });
    });

    function applyEnabledState(on, opts) {
      opts = opts || {};
      if (enable && enable.checked !== on) enable.checked = on;
      if (enable) enable.setAttribute('aria-expanded', on ? 'true' : 'false');
      root.classList.toggle('is-open', !!on);
      if (panel) {
        if (on) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
        panel.hidden = !on;
      }
      setPropsEnabled(on);
      if (on) {
        ensureTextModeDefault();
        syncModeUI();
        // Font list expanded by default for Text / Both only (closes after pick)
        var modeOn = currentMode();
        delete root.dataset.reFontPicked;
        if (modeOn === 'text' || modeOn === 'both') {
          openFontPicker({ skipFocus: true });
        } else {
          closeFontPicker();
        }
        if (!opts.skipFocus) {
          var mode = currentMode();
          var focusEl = mode === 'custom' ? customInput : (mode === 'image' ? fileInput : textInput);
          if (focusEl) {
            try { focusEl.focus({ preventScroll: false }); } catch (e) { try { focusEl.focus(); } catch (e2) {} }
          }
        }
      } else {
        if (typeHidden) typeHidden.value = '';
        root.classList.remove('is-custom', 'is-text', 'is-image', 'is-both', 'is-sides-both');
        closeFontPicker();
        updateEstTotal();
        if (!opts.skipFeeClear) {
          window.RudixEngraving && window.RudixEngraving.removeFees();
        }
      }
    }

    root._rudixApplyEnabled = applyEnabledState;
    root._rudixSetProductPrice = function (cents) {
      if (typeof cents === 'number' && !isNaN(cents) && cents >= 0) {
        productPriceCents = cents;
        root.dataset.productPriceCents = String(cents);
        updateEstTotal();
      }
    };

    if (enable) {
      enable.addEventListener('change', function () {
        applyEnabledState(!!enable.checked);
      });
    }

    // Variant price updates (Impulse + generic)
    function onVariantPrice(cents) {
      root._rudixSetProductPrice(cents);
    }
    document.addEventListener('variant:change', function (e) {
      var v = e && e.detail && e.detail.variant;
      if (v && typeof v.price === 'number') onVariantPrice(v.price);
    });
    // Price node mutations (variant innerHTML, currency apps). Our overlay writes set mainPrice.ignore.
    try { bindMainPriceObserver(); } catch (err) {}

    window.addEventListener('resize', function () {
      if (enable && enable.checked) fitPreviewText();
    });

    (function parkBackFieldsBesideFront() {
      var wrap = root.querySelector('[data-eng-text-wrap]');
      if (!wrap || !textInput || !textBack) return;
      var frontField = textInput.closest('.rudix-engraving__field');
      var backField = textBack.closest('.rudix-engraving__field');
      var frontFont = root.querySelector('[data-eng-font-wrap]');
      var backFont = root.querySelector('[data-eng-font-wrap-back]');
      if (frontField) frontField.classList.add('rudix-engraving__field--front-text');
      if (backField && frontField && backField.parentElement !== wrap) {
        backField.classList.add('rudix-engraving__field--back-text');
        frontField.insertAdjacentElement('afterend', backField);
      }
      if (frontFont && backFont && backFont.parentElement !== wrap) {
        frontFont.insertAdjacentElement('afterend', backFont);
      }
    })();

    frontPicker = createFontPicker(root.querySelector('[data-font-picker-role="front"]'));
    backPicker = createFontPicker(root.querySelector('[data-font-picker-role="back"]'));
    ensureTextModeDefault();
    syncModeUI();
    applyEnabledState(!!(enable && enable.checked), { skipFeeClear: true, skipFocus: true });

    // Expose hooks BEFORE placeAtcEst — a DOM insert error must not leave init half-done
    // (missing _rudixSetPreviewSide / _rudixGetState breaks delegated Back preview + cart fee sync).
    root._rudixSync = syncModeUI;
    root._rudixSetPreviewSide = setPreviewSide;
    root._rudixUpdatePreview = updatePreview;
    root._rudixGetState = function () {
      var mode = currentMode();
      var sidesBoth = bothSidesOn();
      return {
        enabled: !!(enable && enable.checked),
        mode: mode,
        variantId: (mode === 'custom' ? '' : (variants[mode] || '')),
        sideVariantId: (sidesBoth && mode !== 'custom') ? (variants.side || '') : '',
        bothSides: sidesBoth,
        sideLabel: sidesBoth ? 'Both sides' : 'One side',
        feeCents: feeCentsFor(mode),
        isQuote: mode === 'custom',
        allVariantIds: [variants.text, variants.image, variants.both, variants.side].filter(Boolean)
      };
    };

    placeAtcEst();
  }

  function allRoots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-rudix-engraving]'));
  }

  function getActiveState() {
    var roots = allRoots();
    for (var i = 0; i < roots.length; i++) {
      if (roots[i]._rudixGetState) {
        var s = roots[i]._rudixGetState();
        if (s.enabled) return s;
      }
    }
    return null;
  }

  async function cartJson() {
    var r = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    return r.json();
  }

  function refreshCartUI() {
    try {
      if (window.theme && theme.cart) {
        if (typeof theme.cart.getCart === 'function') theme.cart.getCart();
      }
    } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (e2) {}
  }

  function bareFetch() {
    return window.__rudixOrigFetch || window.fetch;
  }

  function readEngravingState() {
    var roots = allRoots();
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var enable = root.querySelector('[data-eng-enable]');
      if (!enable || !enable.checked) continue;
      var modeEl = root.querySelector('[data-eng-mode]:checked');
      var mode = modeEl ? modeEl.value : 'text';
      var sideEl = root.querySelector('[data-eng-side]:checked');
      var both = !!(sideEl && sideEl.value === 'both');
      var idMap = { text: root.dataset.variantText, image: root.dataset.variantImage, both: root.dataset.variantBoth };
      var fallback = { text: '50615385424069', image: '50615385456837', both: '50615385489605' };
      return {
        enabled: true,
        mode: mode,
        isQuote: mode === 'custom',
        variantId: mode === 'custom' ? '' : (idMap[mode] || fallback[mode] || ''),
        bothSides: both,
        sideVariantId: (both && mode !== 'custom') ? (root.dataset.variantSide || '50618025214149') : '',
        sideLabel: both ? 'Both sides' : 'One side'
      };
    }
    return null;
  }

  function noteFee(msg) {
    try {
      var root = document.querySelector('[data-rudix-engraving]');
      if (root) root.setAttribute('data-fee-debug', msg);
    } catch (e) {}
  }

  async function removeFees() {
    try {
      var ids = {
        '50615385424069': 0,
        '50615385456837': 0,
        '50615385489605': 0,
        '50618025214149': 0
      };
      allRoots().forEach(function (root) {
        ['variantText', 'variantImage', 'variantBoth', 'variantSide'].forEach(function (k) {
          if (root.dataset[k]) ids[String(root.dataset[k])] = 0;
        });
      });
      await bareFetch()('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: ids })
      });
    } catch (e) { noteFee('remove-failed'); }
  }

  // Jewellery Engraving fee variants: text, image, text+image, second side.
  function feeVariantSet() {
    var ids = {
      '50615385424069': 1,
      '50615385456837': 1,
      '50615385489605': 1,
      '50618025214149': 1
    };
    allRoots().forEach(function (root) {
      ['variantText', 'variantImage', 'variantBoth', 'variantSide'].forEach(function (k) {
        if (root.dataset[k]) ids[String(root.dataset[k])] = 1;
      });
    });
    return ids;
  }

  function lineVariantId(item) {
    if (!item) return '';
    if (item.variant_id != null && item.variant_id !== '') return String(item.variant_id);
    return String(item.id || '');
  }

  function lineProp(item, name) {
    var props = item && item.properties;
    if (!props) return '';
    if (Array.isArray(props)) {
      for (var i = 0; i < props.length; i++) {
        var row = props[i];
        if (!row) continue;
        if (row.name === name || row[0] === name) return row.value || row[1] || '';
      }
      return '';
    }
    if (props[name] == null) return '';
    return String(props[name]);
  }

  function isFeeLine(item, feeIds) {
    if (!item) return false;
    if (feeIds[lineVariantId(item)]) return true;
    var flag = lineProp(item, '_Engraving fee');
    return flag === 'true' || flag === '1';
  }

  // Which existing lines a new engraving of this pendant variant must replace.
  // This pendant: cart line whose variant_id equals the product form's id.
  // Fees added with it: Jewellery Engraving lines (the four fee variants, or
  // _Engraving fee) that sit in the cart immediately after that pendant.
  // Other jewellery (any other variant) is never put in the updates map.
  // If the cart contains only this variant plus fee lines, every fee line is
  // treated as this pendant's — including a fee that is not trailing it.
  function pendantReplacementUpdates(items, pendantVariantId, feeIds) {
    var vid = String(pendantVariantId || '').trim();
    var updates = {};
    if (!vid || feeIds[vid] || !items || !items.length) return updates;

    var groups = [];
    var current = null;
    var otherProduct = false;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (isFeeLine(item, feeIds)) {
        if (!current) {
          current = { parent: null, fees: [] };
          groups.push(current);
        }
        current.fees.push(item);
      } else {
        if (lineVariantId(item) !== vid) otherProduct = true;
        current = { parent: item, fees: [] };
        groups.push(current);
      }
    }

    function zeroItem(it) {
      if (it && it.key) updates[it.key] = 0;
    }

    if (!otherProduct) {
      for (var k = 0; k < items.length; k++) {
        var only = items[k];
        if (isFeeLine(only, feeIds) || lineVariantId(only) === vid) zeroItem(only);
      }
      return updates;
    }

    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      if (!group.parent || lineVariantId(group.parent) !== vid) continue;
      zeroItem(group.parent);
      for (var f = 0; f < group.fees.length; f++) zeroItem(group.fees[f]);
    }
    return updates;
  }

  // Drop the previous choice for this pendant before the one new add.
  // /cart/update.js quantity 0 by line key, so a shared fee variant used by
  // another piece of jewellery is left alone.
  async function removePreviousPendantChoice(pendantVariantId, signal) {
    var vid = String(pendantVariantId || '').trim();
    if (!vid) return;
    var feeIds = feeVariantSet();
    if (feeIds[vid]) return;
    if (signal && signal.aborted) {
      var aborted = new Error('aborted');
      aborted.name = 'AbortError';
      throw aborted;
    }
    var resp = await bareFetch()('/cart.js?rudix_ts=' + Date.now(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      signal: signal
    });
    var raw = '';
    try { raw = await resp.text(); } catch (eRead) { raw = ''; }
    if (!resp.ok) throw new Error(raw.slice(0, 180) || 'Could not read the cart');
    var cart = null;
    try { cart = JSON.parse(raw); } catch (eJson) { cart = null; }
    var updates = pendantReplacementUpdates((cart && cart.items) || [], vid, feeIds);
    var keys = Object.keys(updates);
    if (!keys.length) return;
    noteFee('replace-clear ' + keys.length);
    var upd = await bareFetch()('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }),
      signal: signal
    });
    var updText = '';
    try { updText = await upd.text(); } catch (eUpd) { updText = ''; }
    if (!upd.ok) throw new Error(updText.slice(0, 180) || 'Could not replace the previous engraving');
    noteFee('replace-cleared ' + keys.length);
  }

  function feeLineItems(state) {
    var items = [{
      id: Number(state.variantId),
      quantity: 1,
      properties: {
        '_Engraving fee': 'true',
        'Engraving type': TYPE_LABELS[state.mode] || state.mode,
        'Side': state.sideLabel || 'One side'
      }
    }];
    if (state.bothSides && state.sideVariantId) {
      items.push({
        id: Number(state.sideVariantId),
        quantity: 1,
        properties: {
          '_Engraving fee': 'true',
          'Engraving type': 'Second side',
          'Side': 'Both sides'
        }
      });
    }
    return items;
  }

  // Removes any previous fee lines, then adds the current fee (and second side).
  // Rejects if the add does not succeed so callers can wait before opening the cart.
  async function addFeeLines(state, opts) {
    // skipRemove: the caller already removed only this pendant's fee lines.
    if (!opts || !opts.skipRemove) await removeFees();
    var addResp = await bareFetch()('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: feeLineItems(state) }),
      signal: opts && opts.signal
    });
    var addText = '';
    try { addText = await addResp.text(); } catch (e2) {}
    noteFee((addResp.ok ? 'added ' : 'fail ') + addResp.status + ' ' + addText.slice(0, 180));
    if (!addResp.ok) throw new Error('fee add failed');
    refreshCartUI();
    return addResp;
  }

  async function syncFee(state) {
    if (!state || !state.enabled || !state.variantId) state = readEngravingState() || getActiveState();
    if (!state || !state.enabled || state.isQuote || !state.variantId) {
      noteFee('no-fee');
      await removeFees();
      refreshCartUI();
      return;
    }
    try {
      await addFeeLines(state);
    } catch (e) {
      noteFee('sync-failed');
    }
  }

  var pendingSync = null;
  function afterMainAdd(state) {
    var snap = state || window.__rudixEngravingPendingState || null;
    if (pendingSync) return pendingSync;
    pendingSync = syncFee(snap).finally(function () {
      pendingSync = null;
      setTimeout(refreshCartUI, 200);
    });
    return pendingSync;
  }

  // Patch fetch to detect cart/add (Impulse uses theme.routes.cartAdd)
  if (!window.__rudixEngravingFetchPatched) {
    window.__rudixEngravingFetchPatched = true;
    var origFetch = window.__rudixOrigFetch || window.fetch.bind(window);
    window.__rudixOrigFetch = origFetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (typeof input !== 'string' && input && input.method) || 'GET').toUpperCase();
      var isAdd = !!(url && /\/cart\/add(\.js)?(\?|$)/.test(String(url)) && method === 'POST');
      var body = (init && init.body) || '';
      var isFee = false;
      try {
        if (typeof body === 'string' && body.indexOf('_Engraving fee') !== -1) isFee = true;
        if (body && typeof FormData !== 'undefined' && body instanceof FormData) {
          if (body.get('properties[_Engraving fee]')) isFee = true;
        }
      } catch (e) {}
      // Snapshot before the theme re-renders the product form.
      var ours = false;
      try {
        var hdrs = init && init.headers;
        if (hdrs && typeof hdrs.get === 'function') ours = hdrs.get('X-Rudix-Engraving-Add') === '1';
        else if (hdrs && typeof hdrs === 'object') ours = hdrs['X-Rudix-Engraving-Add'] === '1';
      } catch (eH) {}
      // Shop's click can start a second pendant add before our listener, or
      // cartCreate a pendant-only checkout. While a Buy with Shop intercept is
      // active, drop those. Our own add uses bareFetch and is not touched.
      // A one-tick defer covers a window listener that already called fetch
      // in this same click, before the suppress flag flipped.
      var bodyText = typeof body === 'string' ? body : '';
      var urlText = String(url || '');
      var foreignCartCreate = !ours && bodyText.indexOf('cartCreate') !== -1 && urlText.indexOf('graphql') !== -1;
      var foreignPendantAdd = isAdd && !isFee && !ours;
      if (foreignPendantAdd || foreignCartCreate) {
        if (window.__rudixSuppressForeignCartAdd) {
          noteFee(foreignCartCreate ? 'blocked-foreign-cart-create' : 'blocked-foreign-cart-add');
          return Promise.resolve(new Response('{"items":[],"data":null}', {
            status: 200,
            headers: { 'Content-Type': 'application/json' }
          }));
        }
        // init may be omitted. Only defer once so the real add still runs
        // when this was not a Shop intercept.
        if (!(init && init.__rudixPass)) {
          var engravingOn = false;
          try {
            var live = readEngravingState() || getActiveState();
            engravingOn = !!(live && live.enabled && !live.isQuote && live.variantId);
          } catch (eLive) {}
          if (engravingOn) {
            var fetchInput = input;
            var fetchInit = init;
            var fetchThis = this;
            return new Promise(function (resolve, reject) {
              setTimeout(function () {
                if (window.__rudixSuppressForeignCartAdd) {
                  noteFee(foreignCartCreate ? 'blocked-foreign-cart-create' : 'blocked-foreign-cart-add');
                  resolve(new Response('{"items":[],"data":null}', {
                    status: 200,
                    headers: { 'Content-Type': 'application/json' }
                  }));
                  return;
                }
                var nextInit = fetchInit ? Object.assign({}, fetchInit) : {};
                nextInit.__rudixPass = 1;
                window.fetch.call(fetchThis, fetchInput, nextInit).then(resolve, reject);
              }, 0);
            });
          }
        }
      }
      var snap = (isAdd && !isFee) ? (readEngravingState() || window.__rudixEngravingPendingState || getActiveState()) : null;
      var pending = origFetch.apply(this, arguments);
      if (!isAdd || isFee) return pending;
      // Hold the add response until the fee lines are in the cart, so checkout
      // cannot open on the pendant alone.
      return pending.then(function (resp) {
        if (!resp || !resp.ok) return resp;
        return syncFee(snap).then(function () { return resp; }, function () { return resp; });
      });
    };
  }

  // Impulse success event — most reliable hook for fee add + drawer rebuild
  if (!window.__rudixEngravingAjaxHook) {
    window.__rudixEngravingAjaxHook = true;
    document.addEventListener('ajaxProduct:added', function () {
      // File uploads add the fee before this event. Do not removeFees again
      // or checkout can open in the gap.
      if (window.__rudixEngravingFeeReady) {
        window.__rudixEngravingFeeReady = false;
        refreshCartUI();
        return;
      }
      afterMainAdd();
    });
  }

  // Patch Impulse AjaxProduct to use FormData when an engraving file is present
  // (Impulse serialize() strips file inputs).
  function patchImpulseAjaxProduct() {
    if (!window.theme || !theme.AjaxProduct || !theme.AjaxProduct.prototype) return;
    var Proto = theme.AjaxProduct.prototype;
    if (Proto.__rudixEngPatched) return;
    Proto.__rudixEngPatched = true;
    var orig = Proto.addItemFromForm;
    Proto.addItemFromForm = function (evt, callback) {
      var form = this.form;
      var fileNodes = form ? form.querySelectorAll('[data-prop-file]') : [];
      var hasFile = false;
      for (var fi = 0; fi < fileNodes.length; fi++) {
        var fileNode = fileNodes[fi];
        if (!fileNode.disabled && fileNode.files && fileNode.files.length) hasFile = true;
      }
      if (!hasFile) {
        return orig.call(this, evt, callback);
      }
      evt.preventDefault();
      if (this.addToCart) this.addToCart.classList.add('btn--loading');
      var self = this;
      var fd = new FormData(form);
      // Ensure quantity
      if (!fd.get('quantity')) fd.set('quantity', '1');
      fetch((theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (self.addToCart) self.addToCart.classList.remove('btn--loading');
          if (data && data.status === 422) {
            if (typeof self.error === 'function') self.error(data);
            return;
          }
          if (typeof self.success === 'function') self.success(data);
          // Fee sync via ajaxProduct:added / afterMainAdd
        })
        .catch(function (err) {
          if (self.addToCart) self.addToCart.classList.remove('btn--loading');
          console.warn('[RudixEngraving] FormData ATC failed', err);
        });
    };
  }

  document.addEventListener('pointerdown', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var hit = t.closest('[data-add-to-cart], button[name="add"], .shopify-payment-button, .shopify-payment-button__button, shopify-accelerated-checkout');
    if (!hit) return;
    window.__rudixEngravingPendingState = getActiveState();
  }, true);

  function formHasEngravingFile(form) {
    var fileNodes = form.querySelectorAll('input[type="file"]');
    for (var fi = 0; fi < fileNodes.length; fi++) {
      var node = fileNodes[fi];
      if (node.disabled) continue;
      if (node.files && node.files.length) return true;
    }
    return false;
  }

  // Image engraving has no text. Disable the live font inputs so a theme
  // submit cannot attach the Georgia defaults.
  function suppressImageFonts(form) {
    if (!form) return;
    var nodes = form.querySelectorAll('input[name="properties[Font]"], input[name="properties[Back font]"]');
    for (var i = 0; i < nodes.length; i++) nodes[i].disabled = true;
  }

  function showAddError(form, message) {
    try {
      var old = form.querySelector('.errors');
      if (old) old.remove();
      var errorDiv = document.createElement('div');
      errorDiv.className = 'errors text-center';
      errorDiv.textContent = message;
      form.appendChild(errorDiv);
    } catch (err) {}
  }

  function isAbortError(err) {
    if (!err) return false;
    if (err.name === 'AbortError') return true;
    var msg = String(err.message || '');
    return msg === 'The operation was aborted.' || msg === 'The user aborted a request.' || msg === 'aborted';
  }

  // Impulse draws the horseshoe with .btn--loading and also disables the button.
  function releaseAddToCart(form) {
    var scopes = [];
    if (form && form.querySelectorAll) scopes.push(form);
    else {
      var forms = document.querySelectorAll('form.product-single__form, form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) scopes.push(forms[i]);
      if (!scopes.length) scopes.push(document);
    }
    for (var s = 0; s < scopes.length; s++) {
      var scope = scopes[s];
      if (scope.dataset && scope.classList && (
        scope.classList.contains('product-single__form') ||
        (scope.getAttribute && (scope.getAttribute('action') || '').indexOf('/cart/add') !== -1)
      )) {
        scope.dataset.rudixEngSubmitting = '';
      }
      if (!scope.querySelectorAll) continue;
      var btns = scope.querySelectorAll('[data-add-to-cart], button[name="add"]');
      for (var b = 0; b < btns.length; b++) {
        var btn = btns[b];
        if (!btn || !btn.classList) continue;
        btn.classList.remove('btn--loading');
        btn.disabled = false;
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        if (btn.hasAttribute('aria-busy')) btn.setAttribute('aria-busy', 'false');
      }
    }
  }

  function clearStaleEngravingGuards() {
    var ctrl = window.__rudixEngravingAbort;
    window.__rudixEngravingAbort = null;
    window.__rudixAcceleratedBusy = false;
    window.__rudixSuppressForeignCartAdd = false;
    if (ctrl) {
      try { ctrl.abort(); } catch (eAbort) {}
    }
    var hosts = document.querySelectorAll('[data-rudix-shop-blocked]');
    for (var h = 0; h < hosts.length; h++) {
      if (hosts[h].style) hosts[h].style.pointerEvents = '';
      hosts[h].removeAttribute('data-rudix-shop-blocked');
    }
    releaseAddToCart(null);
  }

  // pageshow runs for a normal load and for a bfcache restore (event.persisted).
  // Checkout -> Back freezes the button in btn--loading with the submit guard
  // still set, so the next click preventDefaults and never clears the horseshoe.
  if (!window.__rudixEngravingPageShow) {
    window.__rudixEngravingPageShow = true;
    window.addEventListener('pageshow', function () {
      clearStaleEngravingGuards();
    });
  }

  function settleEngravingSubmit(form, ok, errText) {
    window.__rudixEngravingAbort = null;
    releaseAddToCart(form);
    if (!ok) {
      showAddError(form, errText || 'Could not add engraving. Please try again.');
    }
    // Impulse only drops its loading state when the add settles. Always fire
    // ajaxProduct:added, including when /cart/update.js or /cart/add.js fails.
    // The fee already traveled with that single add, or the add did not happen.
    // Fee-ready stops this event from removeFees() or a second pendant/fee add.
    window.__rudixEngravingFeeReady = true;
    try {
      (form || document).dispatchEvent(new CustomEvent('ajaxProduct:added', {
        bubbles: true,
        detail: { product: {} }
      }));
    } catch (errEv) {}
  }

  function findProductFormNear(el) {
    if (el && el.closest) {
      var near = el.closest('form.product-single__form') || el.closest('form[action*="/cart/add"]');
      if (near) return near;
    }
    return document.querySelector('form.product-single__form') || document.querySelector('form[action*="/cart/add"]');
  }

  function hitAcceleratedCheckout(e) {
    var path = [];
    try {
      if (e && typeof e.composedPath === 'function') path = e.composedPath() || [];
    } catch (err) { path = []; }
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (!n) continue;
      var tag = (n.localName || n.nodeName || '').toLowerCase();
      if (tag === 'shopify-accelerated-checkout' || tag === 'shopify-accelerated-checkout-cart' || tag === 'shopify-buy-it-now-button') {
        return n;
      }
      if (n.classList && (
        n.classList.contains('shopify-payment-button') ||
        n.classList.contains('shopify-payment-button__button') ||
        n.classList.contains('shopify-payment-button__more-options')
      )) {
        return n;
      }
    }
    var t = e && e.target;
    if (!t || !t.closest) return null;
    return t.closest(
      '.shopify-payment-button, .shopify-payment-button__button, .shopify-payment-button__more-options, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, shopify-buy-it-now-button'
    );
  }

  function collectFormProperties(form, state) {
    var fd = new FormData(form);
    var props = {};
    fd.forEach(function (val, key) {
      var m = /^properties\[(.+)\]$/.exec(key);
      if (!m || val == null || val === '') return;
      if (typeof File !== 'undefined' && val instanceof File) return;
      if (state.mode === 'image' && (m[1] === 'Font' || m[1] === 'Back font')) return;
      props[m[1]] = String(val);
    });
    return props;
  }

  function parseAddResponse(resp, text) {
    if (!resp.ok) throw new Error(text.slice(0, 180) || 'add failed');
    var data = null;
    try { data = JSON.parse(text); } catch (err) { data = null; }
    if (data && data.status && Number(data.status) >= 400) {
      throw new Error(data.description || data.message || 'add failed');
    }
    return data;
  }

  // Buy with Shop used to check out the pendant only. This is the one cart add
  // for that button when engraving has a priced fee: pendant (multipart when a
  // file is chosen) plus the fee, then /checkout. Callers must stop Shop's own
  // add first. Do not also add the pendant from the form submit handler.
  function accelerateWithEngraving(form, state, signal) {
    if (state.mode === 'image') suppressImageFonts(form);
    var hasFile = formHasEngravingFile(form);
    var addUrl = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
    var fd = new FormData(form);
    var id = fd.get('id');
    // One add only. Shop's own add stays blocked by the caller. Replace this
    // pendant's previous lines first so Back + a new type does not stack.
    return removePreviousPendantChoice(id, signal).then(function () {
      if (hasFile) {
        var fileFd = new FormData(form);
        if (!fileFd.get('quantity')) fileFd.set('quantity', '1');
        if (state.mode === 'image') {
          fileFd.delete('properties[Font]');
          fileFd.delete('properties[Back font]');
        }
        noteFee('accel-file');
        return bareFetch()(addUrl, {
          method: 'POST',
          body: fileFd,
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          signal: signal
        }).then(function (resp) {
          return resp.text().then(function (text) {
            noteFee((resp.ok ? 'accel-file-ok ' : 'accel-file-fail ') + resp.status + ' ' + text.slice(0, 120));
            parseAddResponse(resp, text);
            return addFeeLines(state, { skipRemove: true, signal: signal });
          });
        });
      }

      var qty = parseInt(fd.get('quantity') || '1', 10) || 1;
      var props = collectFormProperties(form, state);
      var items = [{ id: Number(id), quantity: qty, properties: props }];
      items.push({
        id: Number(state.variantId),
        quantity: 1,
        properties: {
          '_Engraving fee': 'true',
          'Engraving type': TYPE_LABELS[state.mode] || state.mode,
          'Side': state.sideLabel || 'One side'
        }
      });
      if (state.bothSides && state.sideVariantId) {
        items.push({
          id: Number(state.sideVariantId),
          quantity: 1,
          properties: {
            '_Engraving fee': 'true',
            'Engraving type': 'Second side',
            'Side': 'Both sides'
          }
        });
      }
      noteFee('accel-send ' + items.length);
      return bareFetch()('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
        signal: signal
      }).then(function (resp) {
        return resp.text().then(function (text) {
          noteFee((resp.ok ? 'accel-ok ' : 'accel-fail ') + resp.status + ' ' + text.slice(0, 140));
          parseAddResponse(resp, text);
        });
      });
    });
  }

  function pricedEngravingState() {
    var state = readEngravingState() || getActiveState();
    if (!state || !state.enabled || state.isQuote || !state.variantId) return null;
    return state;
  }

  // Buy with Shop's gravity-button lives in closed shadow inside the product
  // form and handles click itself (cartCreate / form submit). Stopping only
  // the document click is too late: that handler, or the form submit, still
  // adds the pendant. Stop the whole gesture on window capture, starting at
  // pointerdown, so Shop never adds. One accelerateWithEngraving is the only add.
  function beginShopCheckout(e) {
    var state = pricedEngravingState();
    if (!state) return false;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (window.__rudixAcceleratedBusy && window.__rudixEngravingAbort) return true;
    if (window.__rudixAcceleratedBusy || window.__rudixSuppressForeignCartAdd) {
      window.__rudixAcceleratedBusy = false;
      window.__rudixSuppressForeignCartAdd = false;
    }
    window.__rudixAcceleratedBusy = true;
    window.__rudixSuppressForeignCartAdd = true;
    window.__rudixEngravingPendingState = state;
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    window.__rudixEngravingAbort = ctrl;
    var signal = ctrl ? ctrl.signal : undefined;

    var host = null;
    try { host = hitAcceleratedCheckout(e); } catch (errHost) { host = null; }
    if (host && host.style) {
      host.setAttribute('data-rudix-shop-blocked', '1');
      host.style.pointerEvents = 'none';
    }

    var form = findProductFormNear((host || e.target));
    if (!form) {
      window.__rudixAcceleratedBusy = false;
      window.__rudixSuppressForeignCartAdd = false;
      window.__rudixEngravingAbort = null;
      if (host && host.style) host.style.pointerEvents = '';
      releaseAddToCart(null);
      noteFee('accel-no-form');
      return true;
    }

    var btn = form.querySelector('[data-add-to-cart]');
    if (btn) btn.classList.add('btn--loading');
    noteFee('accel-intercept');

    accelerateWithEngraving(form, state, signal).then(function () {
      if (signal && signal.aborted) return;
      window.__rudixEngravingAbort = null;
      window.__rudixEngravingFeeReady = true;
      // Keep the suppress flag set so a late Shop add cannot land before navigation.
      // pageshow clears it when Back restores this page.
      window.location.href = '/checkout';
    }).catch(function (err) {
      window.__rudixAcceleratedBusy = false;
      window.__rudixSuppressForeignCartAdd = false;
      window.__rudixEngravingAbort = null;
      if (host && host.style) host.style.pointerEvents = '';
      releaseAddToCart(form);
      if (isAbortError(err)) return;
      noteFee('accel-failed');
      showAddError(form, (err && err.message) ? String(err.message).slice(0, 180) : 'Could not start checkout with engraving. Please try again.');
      try {
        var root = form.querySelector('[data-rudix-engraving]') || document.querySelector('[data-rudix-engraving]');
        if (root && typeof root._rudixSync === 'function') root._rudixSync();
      } catch (err2) {}
    });
    return true;
  }

  if (!window.__rudixEngravingAccelHook) {
    window.__rudixEngravingAccelHook = true;
    ['pointerdown', 'mousedown', 'touchstart', 'pointerup', 'mouseup', 'click', 'auxclick', 'touchend', 'keydown'].forEach(function (type) {
      window.addEventListener(type, function (e) {
        if (type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
        if (!hitAcceleratedCheckout(e)) return;
        beginShopCheckout(e);
      }, true);
    });
  }

  if (!window.__rudixEngravingXhrPatched) {
    window.__rudixEngravingXhrPatched = true;
    var origXhrOpen = XMLHttpRequest.prototype.open;
    var origXhrSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__rudixMethod = method;
      this.__rudixUrl = url;
      return origXhrOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      var url = String(this.__rudixUrl || '');
      var method = String(this.__rudixMethod || 'GET').toUpperCase();
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url) && method === 'POST';
      var isFee = false;
      try {
        if (typeof body === 'string' && body.indexOf('_Engraving fee') !== -1) isFee = true;
      } catch (eX) {}
      if (isAdd && !isFee && window.__rudixSuppressForeignCartAdd) {
        noteFee('blocked-foreign-xhr-add');
        var xhr = this;
        setTimeout(function () {
          try {
            Object.defineProperty(xhr, 'status', { configurable: true, get: function () { return 200; } });
            Object.defineProperty(xhr, 'readyState', { configurable: true, get: function () { return 4; } });
            Object.defineProperty(xhr, 'responseText', { configurable: true, get: function () { return '{"items":[]}'; } });
            Object.defineProperty(xhr, 'response', { configurable: true, get: function () { return '{"items":[]}'; } });
          } catch (eDef) {}
          try { if (typeof xhr.onreadystatechange === 'function') xhr.onreadystatechange(); } catch (eRs) {}
          try { xhr.dispatchEvent(new Event('readystatechange')); } catch (eEv) {}
          try { xhr.dispatchEvent(new Event('load')); } catch (eEv2) {}
          try { xhr.dispatchEvent(new Event('loadend')); } catch (eEv3) {}
        }, 0);
        return;
      }
      return origXhrSend.apply(this, arguments);
    };
  }

  // Add the pendant and the engraving fee before the cart drawer or checkout.
  // A chosen file used to return early and let the theme post only the pendant.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('product-single__form')) return;
    // Shop's button is inside this form. If that gesture already started our
    // single add, do not post the pendant again. Stopping without adding is
    // required: a second submit add leaves two pendants and one fee.
    var submitPath = [];
    try { if (typeof e.composedPath === 'function') submitPath = e.composedPath() || []; } catch (ePath) { submitPath = []; }
    var submitFromShop = false;
    for (var si = 0; si < submitPath.length; si++) {
      var sn = submitPath[si];
      if (!sn) continue;
      var stag = (sn.localName || sn.nodeName || '').toLowerCase();
      if (stag === 'shopify-accelerated-checkout' || stag === 'shopify-accelerated-checkout-cart' || stag === 'shopify-buy-it-now-button') submitFromShop = true;
      if (sn.classList && (sn.classList.contains('shopify-payment-button') || sn.classList.contains('shopify-payment-button__button'))) submitFromShop = true;
    }
    if (!submitFromShop && e.submitter && e.submitter.closest) {
      submitFromShop = !!e.submitter.closest('.shopify-payment-button, shopify-accelerated-checkout, shopify-buy-it-now-button');
    }
    // A real in-flight Shop intercept must keep blocking Shop's own submit so
    // the pendant is not added twice. A guard left true by bfcache (no abort
    // controller) is stale: clear it so this click can run.
    var engravingInFlight = !!window.__rudixEngravingAbort;
    if ((window.__rudixAcceleratedBusy || window.__rudixSuppressForeignCartAdd) && !engravingInFlight) {
      window.__rudixAcceleratedBusy = false;
      window.__rudixSuppressForeignCartAdd = false;
    }
    if ((window.__rudixAcceleratedBusy || window.__rudixSuppressForeignCartAdd) && engravingInFlight) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      noteFee('submit-blocked-shop');
      return;
    }
    if (form.dataset.rudixEngSubmitting === '1' && !engravingInFlight) {
      form.dataset.rudixEngSubmitting = '';
      releaseAddToCart(form);
    }
    // Shop button is type=submit inside this form. Only take over that submit
    // when engraving has a priced fee. Otherwise leave Shop's native checkout alone.
    if (submitFromShop && pricedEngravingState()) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (!window.__rudixAcceleratedBusy) beginShopCheckout(e);
      return;
    }
    var state = readEngravingState() || window.__rudixEngravingPendingState;
    if (!state || !state.enabled || state.isQuote || !state.variantId) return;
    if (state.mode === 'image') suppressImageFonts(form);
    if (form.dataset.rudixEngSubmitting === '1') {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return;
    }
    var hasFile = formHasEngravingFile(form);
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    form.dataset.rudixEngSubmitting = '1';
    window.__rudixEngravingPendingState = state;
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    window.__rudixEngravingAbort = ctrl;
    var signal = ctrl ? ctrl.signal : undefined;
    var btn = form.querySelector('[data-add-to-cart]');
    if (btn) btn.classList.add('btn--loading');
    var fd = new FormData(form);
    var id = fd.get('id');
    var qty = parseInt(fd.get('quantity') || '1', 10) || 1;
    var props = {};
    fd.forEach(function (val, key) {
      var m = /^properties\[(.+)\]$/.exec(key);
      if (!m || val == null || val === '') return;
      if (typeof File !== 'undefined' && val instanceof File) return;
      if (state.mode === 'image' && (m[1] === 'Font' || m[1] === 'Back font')) return;
      props[m[1]] = String(val);
    });
    var items = [{ id: Number(id), quantity: qty, properties: props }];
    items.push({
      id: Number(state.variantId),
      quantity: 1,
      properties: {
        '_Engraving fee': 'true',
        'Engraving type': TYPE_LABELS[state.mode] || state.mode,
        'Side': state.sideLabel || 'One side'
      }
    });
    if (state.bothSides && state.sideVariantId) {
      items.push({
        id: Number(state.sideVariantId),
        quantity: 1,
        properties: {
          '_Engraving fee': 'true',
          'Engraving type': 'Second side',
          'Side': 'Both sides'
        }
      });
    }
    function finishSubmit(ok, errText) {
      if (signal && signal.aborted) {
        releaseAddToCart(form);
        return;
      }
      settleEngravingSubmit(form, ok, errText);
    }

    // Replace this pendant variant (and the fee lines that followed it) once,
    // then add exactly one pendant plus the new fee. Not a second add.
    // A failed /cart/update.js must not add again (that would stack a pendant).
    // Either way finishSubmit clears the horseshoe and fires ajaxProduct:added.
    removePreviousPendantChoice(id, signal).then(function () {
      // File upload: the theme form (multipart) is what stores the artwork.
      // Post that first, then await the fee line(s) before the drawer opens.
      if (hasFile) {
        var fileFd = new FormData(form);
        if (!fileFd.get('quantity')) fileFd.set('quantity', '1');
        if (state.mode === 'image') {
          fileFd.delete('properties[Font]');
          fileFd.delete('properties[Back font]');
        }
        var addUrl = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
        noteFee('file-pendant');
        return bareFetch()(addUrl, {
          method: 'POST',
          body: fileFd,
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          signal: signal
        }).then(function (resp) {
          return resp.text().then(function (text) {
            noteFee((resp.ok ? 'file-ok ' : 'file-fail ') + resp.status + ' ' + text.slice(0, 140));
            if (!resp.ok) throw new Error(text.slice(0, 180) || 'pendant add failed');
            var data = null;
            try { data = JSON.parse(text); } catch (err) { data = null; }
            if (data && data.status && Number(data.status) >= 400) {
              throw new Error((data.description || data.message || 'pendant rejected'));
            }
            return addFeeLines(state, { skipRemove: true, signal: signal });
          });
        }).then(function () {
          finishSubmit(true);
        });
      }

      noteFee('sending ' + items.length);
      return bareFetch()('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
        signal: signal
      }).then(function (resp) {
        return resp.text().then(function (text) {
          noteFee((resp.ok ? 'cart-ok ' : 'cart-fail ') + resp.status + ' ' + text.slice(0, 160));
          if (!resp.ok) throw new Error(text.slice(0, 180) || 'add failed');
          var data = null;
          try { data = JSON.parse(text); } catch (err) { data = null; }
          if (data && data.status && Number(data.status) >= 400) {
            throw new Error((data.description || data.message || 'add failed'));
          }
          finishSubmit(true);
        });
      });
    }).catch(function (err) {
      noteFee('cart-request-failed');
      if (isAbortError(err)) {
        releaseAddToCart(form);
        return;
      }
      finishSubmit(false, (err && err.message) ? String(err.message).slice(0, 180) : '');
    });
  }, true);

  function boot() {
    patchImpulseAjaxProduct();
    allRoots().forEach(initRoot);
  }

  // Document-level delegation: survives Impulse AjaxRenderer / GPO form swaps
  if (!window.__rudixEngravingDelegated) {
    window.__rudixEngravingDelegated = true;

    function syncFromEnableEl(enable) {
      if (!enable) return;
      var root = enable.closest('[data-rudix-engraving]');
      if (!root) return;
      if (!root.dataset.reInit) initRoot(root);
      if (typeof root._rudixApplyEnabled === 'function') {
        root._rudixApplyEnabled(!!enable.checked);
      } else {
        root.classList.toggle('is-open', !!enable.checked);
        var panel = root.querySelector('[data-eng-panel]');
        if (panel) {
          panel.hidden = !enable.checked;
          if (enable.checked) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        }
      }
    }

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('[data-eng-enable]')) return;
      syncFromEnableEl(t);
    }, true);

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var enable = t.matches && t.matches('[data-eng-enable]')
        ? t
        : (t.closest('.rudix-engraving__toggle') && t.closest('.rudix-engraving__toggle').querySelector('[data-eng-enable]'));
      if (!enable) return;
      setTimeout(function () { syncFromEnableEl(enable); }, 0);
    }, true);

    // Mode changes after Ajax DOM swap
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('[data-eng-mode]')) return;
      var root = t.closest('[data-rudix-engraving]');
      if (!root) return;
      if (!root.dataset.reInit) initRoot(root);
      root.dataset.reModeTouched = '1';
      // Re-run via apply so fee/est update
      var enable = root.querySelector('[data-eng-enable]');
      if (enable && enable.checked && root._rudixApplyEnabled) {
        root._rudixApplyEnabled(true, { skipFocus: true, skipFeeClear: true });
      }
    }, true);

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('[data-eng-side]')) return;
      var root = t.closest('[data-rudix-engraving]');
      if (!root) return;
      if (!root.dataset.reInit) initRoot(root);
      if (typeof root._rudixSync === 'function') root._rudixSync();
    }, true);

    function previewRootFrom(t) {
      var root = t.closest('[data-rudix-engraving]');
      if (!root) return null;
      if (!root.dataset.reInit) initRoot(root);
      return root;
    }
    function commitPreviewSide(root, side) {
      if (!root || typeof root._rudixSetPreviewSide !== 'function') return;
      root._rudixSetPreviewSide(side, { focusField: true });
    }
    // Only the Front/Back buttons change which text box is showing.
    // Clicking the text box must not flip the side.
    document.addEventListener('pointerdown', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest('[data-eng-preview-side]');
      if (!btn) return;
      commitPreviewSide(previewRootFrom(btn), btn.getAttribute('data-eng-preview-side') === 'back' ? 'back' : 'front');
    }, true);

    // Front/Back preview toggle + live text — delegated so Ajax form swaps keep working.
    // No preventDefault: cancelling the button click restored focus to the front
    // field and its focus handler flipped the tag back to the front words.
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest('[data-eng-preview-side]');
      if (!btn) return;
      var root = previewRootFrom(btn);
      if (!root) return;
      commitPreviewSide(root, btn.getAttribute('data-eng-preview-side') === 'back' ? 'back' : 'front');
    }, true);

    document.addEventListener('input', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      var isBack = t.matches('[data-eng-text-back]');
      var isFront = !isBack && t.matches('[data-eng-text]');
      if (!isBack && !isFront) return;
      var root = t.closest('[data-rudix-engraving]');
      if (!root) return;
      if (!root.dataset.reInit) initRoot(root);
      if (typeof root._rudixUpdatePreview === 'function') {
        root._rudixUpdatePreview();
      }
    }, true);

  }

  if (!window.__rudixEngravingObserver) {
    window.__rudixEngravingObserver = true;
    var moTimer = null;
    function scheduleBoot() {
      if (moTimer) return;
      moTimer = setTimeout(function () {
        moTimer = null;
        boot();
      }, 50);
    }
    try {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i];
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches('[data-rudix-engraving]')) { scheduleBoot(); return; }
            if (n.querySelector && n.querySelector('[data-rudix-engraving]')) { scheduleBoot(); return; }
          }
        }
      });
      var startObs = function () {
        if (document.documentElement) {
          mo.observe(document.documentElement, { childList: true, subtree: true });
        }
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', startObs);
      } else {
        startObs();
      }
    } catch (err) { /* older browsers */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:reorder', boot);

  window.RudixEngraving = {
    syncFee: syncFee,
    removeFees: removeFees,
    afterMainAdd: afterMainAdd,
    boot: boot,
    FONT_GROUPS: FONT_GROUPS
  };
})();
